import React, { useEffect, useRef, useState } from "react";
import ViewTable from "../../../../Components/Common/ViewTable";
import { api, get } from "../../../../utils/api";
import Cards from "../../../../Components/Common/Cards";
import FilterModal from "../../../../Components/Common/FilterModal";
import ActionButtons from "../../../../Components/Common/ActionButtons";
import axios from "axios";
import DeleteDialog from "../../../../Components/Masters/DeleteDialog";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import Add from "./Add";
import { Box } from "@mui/material";
import View from "./View";
import BulkUploadModal from "../../../../Components/Common/BulkUploadModal";
import { fixedTons, truncateNumber } from "../../../../utils/common";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import Scope1Layout from "../../../../Layout/Scope1Layout";
import { useUser } from "../../../../context/AuthContext";
import BulkUpload from "./BulkUpload";
import DeleteAlertDialog from "../../../../Components/Masters/DeleteAlertDialog";

const IndustrialProcess = () => {
  const { user } = useUser();

  const [cardData, setCardData] = useState(null);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const initialStateProduct = {
    date: new Date().toISOString().split("T")[0],
    productName: "",
    sampleBasis: "",
    sampleQuantity: "",
    unit: "",
    processes:
      // id && element && Array.isArray(element?.processes)
      //   ? element.processes.map((proc) => ({
      //       processName: proc.processName || "",
      //       airEmissions: proc.airEmissions || [],
      //       emissions: Array.isArray(proc.emissions)
      //         ? proc.emissions.map((e) => ({
      //             emissionsName: e.emissionsName || "",
      //             unit: e.unit || "",
      //             quantity: e.quantity || "",
      //           }))
      //         : [{ emissionsName: "", unit: "", quantity: "" }],
      //     }))
      //   :
      [
        {
          processName: "",
          airEmissions: [],
          emissions: [{ emissionsName: "", unit: "", quantity: "" }],
        },
      ],
  };
  const [tableData, setTableData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filterObj, setFilterObj] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [filters, setFilters] = useState({
    facility: [],
    wasteType: [],
    wasteManagementMethod: [],
  });
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const [isLoading, setIsLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [deletedItemId, setDeletedItemId] = useState("");
  const [selectedProduct, setSelectedProduct] = useState("");
  const [selectedYear, setSelectedYear] = useState(""); // Stores the selected year
  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [excelData, setExcelData] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(""); // Stores the selected month
  const [bulkUploadTable, setBulkUploadTable] = useState(true);
  const [formDataBulkUpload, setFormDataBulkUpload] =
    useState(initialStateProduct);
  const [matchData, setMatchData] = useState([]);
  const fetchExcelData = async () => {
    await get("/scope1/fugitiveEmission/industrialProcess/generateExcel")
      .then((res) => {
        let data = res?.data?.data;
        let arr =
          data.length > 0
            ? data.map((el, idx) => {
                return {
                  "S No.": idx + 1,
                  "Month (in 01/25 or Jan-25)": "",
                  Product: el?.product,
                  "Quantity Produced": "",
                };
              })
            : [];
        console.log("arrr", arr);
        setExcelData(arr);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchExcelData();
  }, []);
  const uploadErrorClose = () => {
    setBulkUploadTable(true);
  };
  const updatePage = () => {
    if (page > 1 && tableData?.length === 1) {
      setPage(page - 1);
    }
    setIsLoading(true);
    fetchData();
  };

  const fetchData = async () => {
    await fetchFilters();
    await fetchCardData();
    let filter = { ...filterObj };
    console.log(filter, "selectedfilter");
    if (filter.quantity) {
      filter.minQty = parseInt(filterObj.quantity.min);
      filter.maxQty = parseInt(filterObj.quantity.max);
      delete filter.quantity;
    }
    if (filter.createdAt) {
      filter.startDate = filter?.createdAt?.start || "";
      filter.endDate = filter?.createdAt?.end || "";
      delete filter?.createdAt;
    }
    if (filter.consumptionMonth) {
      filter.startMonth = filter?.consumptionMonth?.start || "";
      filter.endMonth = filter?.consumptionMonth?.end || "";
      delete filter?.consumptionMonth;
    }

    console.log("filter", filter);
    const queryParams = new URLSearchParams({
      ...filter,
      page: currentPage,
      limit: rowsPerPage,
      sortField: sortConfig.key,
      sortOrder: sortConfig.direction,
    }).toString();
    try {
      const res = await get(
        `/scope1/fugitiveEmission/getAllIndustrialProcesss?${queryParams}`
      );
      setTotalPages(res.data.totalPages);
      setTableData(res.data.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [sortConfig, page, currentPage, filterObj]);

  const fetchFilters = async () => {
    try {
      const { data } = await get(`/scope1/fugitiveEmission/filter`);
      const { product } = data?.data || {};
      setFilters({
        product: product || [],
      });
      // Set default selected product only if not already set
      if (product?.[0]?.productName) {
        setSelectedProduct(product[0].productName);
      }

      console.log(product, "prod");
    } catch (err) {
      console.error("Fetch Filters Error:", err);
    }
  };

  const fetchProducts = async () => {
    try {
      const res = await get(`/master/product/productsList`);
      const product = res?.data?.data || {};
      console.log(product, "product1");
      setProducts(product);
    } catch (err) {
      console.error("Fetch Filters Error:", err);
    }
  };

  useEffect(() => {
    fetchFilters();
    fetchProducts();
  }, []);

  const fetchCardData = async () => {
    try {
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth() + 1;
      const productToFetch =
        selectedProduct || filters?.product?.[0]?.productName;

      if (!productToFetch) return; // Don't fetch if no product selected

      let response = await get(
        `/scope1/fugitiveEmission/industrialProcessCardData?product=${productToFetch}&year=${
          selectedYear || currentYear
        }&month=${selectedMonth || currentMonth}`
      );
      setCardData(response.data.data);
    } catch (error) {
      console.error("Error fetching card data:", error);
    }
  };

  useEffect(() => {
    fetchCardData();
  }, [selectedMonth, selectedYear, selectedProduct]);

  const openModal = (type, dataForEdit) => {
    if (type === "add") {
      setIsModalOpen(true);
    } else if (type === "edit") {
      setEditModal(true);
      console.log("data", dataForEdit);
      setEditData(dataForEdit);
      setViewModal(false);
    }
  };

  const handleEdit = () => {
    // data.createdAt = data?.createdAt.split("T")[0];
    // data.dateOfTravel = data?.dateOfTravel.split("T")[0];
    setEditData(editData);
    setViewModal(false);
    setEditModal(true);
  };

  const openViewModal = (data) => {
    setEditData(data);
    setViewModal(true);
  };

  const handleSort = (key, direction) => {
    setSortConfig({ key, direction });
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    console.log("page change", newPage);
  };

  const handleFilterChange = (newFilterObj) => {
    setFilterObj(newFilterObj);
    setCurrentPage(1);
    console.log("Applied Filters:", newFilterObj);
  };

  console.log("editdata", editData);

  const closeModal = (type) => {
    if (type === "add") {
      setIsModalOpen(false);
    } else if (type === "edit") {
      setEditModal(false);
      setEditData({});
    }
  };

  const tableContainerRef = useRef(null); // Reference to the table container
  const [isShortContent, setIsShortContent] = useState(false);

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height

      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 3.2);
    }
  }, [tableData]);

  const handleSelectChange = (key, value, filterType) => {
    console.log(key, value, filterType, "k1");
    setSelectedProduct(value);
  };

  const handleDeleteOpen = (itemId) => {
    setDeletedItemId(itemId);
    setDeleteDialog(true);
  };

  const handleCloseBulkUpload = () => {
    setBulkUploadModal(false);
    fetchData();
  };

  let bannerData = [
    {
      title: "Most Produced Product",
      description: cardData?.topTwoProducts?.map((el) => el?.product) || [
        "N/A",
      ],
    },
    {
      title: "Total Quantity Produced",
      description: fixedTons(
        cardData?.totalForGivenProduct?.[0]?.totalQuantity || 0
      ),
      filter: "option",
      key: "product",
      filterValues: filters?.product?.map((el) => el?.productName) || [],
      defaultValue: selectedProduct,
    },
    {
      title: "Quantity Produced",
      description: truncateNumber(cardData?.monthly?.[0]?.quantity || 0),
      filter: "date",
      unit: cardData?.monthly?.[0]?.unit || "",
      defaultValue: {},
    },
  ];

  const inputData = [
    {
      fieldName: "consumptionPeriod",
      title: "Consumption Month",
      required: true,
      type: "date",
      width: "2rem",
    },
    {
      fieldName: "product",
      title: "Product",
      type: "select",
      url: "/master/product/productsList",
      width: "5rem",
      field: "productName",
    },
    {
      fieldName: "quantityProduced",
      title: "Quantity Produced",
      placeholder: "Enter Quantity",
      type: "number",
      options: ["Kg", "Tons"],
    },
    {
      fieldName: "editRemarkReason",
      title: "Edit Remark Reason",
      placeholder: "Additional edit remarks",
      type: "text",
      condition: true,
    },
  ];

  const headers = [
    { key: "createdAt", label: "Date", sortable: true, width: "12%" },
    {
      label: "Consumption Month",
      key: "consumptionPeriod",
      sortable: true,
      width: "15%",
    },
    {
      label: "Product",
      key: "product",
      sortable: true,
      field: "productName",
      width: "30%",
    },
    {
      key: "quantityProduced",
      label: "Quantity Produced",
      sortable: true,
      width: "35%",
    },
    // {
    //   key: "quantityProduced.unit",
    //   label: "Unit",
    //   sortable: true,
    //   width: "20%",
    // },
  ];
  const simpleUnits = [
    {
      Mass: ["Gram", "Kilogram", "Metric Tonne", "Milligram"],
    },
    {
      Volume: ["Milliliter", "Liter", "Cubic Meter", "Cubic Centimeter"],
    },
    {
      Bulk: [
        "Per Batch",
        "Per Lot",
        "Per Unit of Product",
        "Per Drum / Container",
        "Per Reactor Cycle",
        "Per Run",
      ],
    },
    {
      Time: [
        "Per Hour (Hr)",
        "Per Day",
        " Per Shift",
        " Per Week",
        "Per Month",
        " Per Year",
      ],
    },
    {
      Operational: [
        "Per Machine",
        " Per Equipment",
        " Per Production Line",
        " Per Facility",
      ],
    },
  ];
  const typeofemissions = [
    "Carbon dioxide ; CO2",
    "Methane – non-fossil ; CH4",
    "Methane – fossil ; CH4",
    "Nitrous oxide ; N2O",
    "Nitrogen trifluoride ; NF3",
    "Sulfur hexafluoride ; SF6",
    "HFC-23 ; CHF3",
    "HFC-32 ; CH2F2",
    "HFC-41 ; CH3F",
    "HFC-125 ; CHF2CF3",
    "HFC-134 ; CHF2CHF2",
    "HFC-134a ; CH2FCF3",
    "HFC-143 ; CH2FCHF2",
    "HFC-143a ; CH3CF3",
    "HFC-152 ; CH2FCH2F",
    "HFC-152a ; CH3CHF2",
    "HFC-161 ; CH3CH2F",
    "HFC-227ca ; CF3CF2CHF2",
    "HFC-227ea ; CF3CHFCF3",
    "HFC-236cb ; CH2FCF2CF3",
    "HFC-236ea ; CHF2CHFCF3",
    "HFC-236fa ; CF3CH2CF3",
    "HFC-245ca ; CH2FCF2CHF2",
    "HFC-245cb ; CF3CF2CH3",
    "HFC-245ea ; CHF2CHFCHF2",
    "HFC-245eb ; CH2FCHFCF3",
    "HFC-245fa ; CHF2CH2CF3",
    "HFC-263fb ; CH3CH2CF3",
    "HFC-272ca ; CH3CF2CH3",
    "HFC-329p ; CHF2CF2CF2CF3",
    "HFC-365mfc ; CH3CF2CH2CF3",
    "HFC-43-10mee ; CF3CHFCHFCF2CF3",
    "HFO-1123 ; CHF=CF2",
    "HFO-1132a ; CH2=CF2",
    "HFO-1141 ; CH2=CHF",
    "HFO-1225ye(Z) ; (Z)-CF3CF=CHF",
    "HFO-1225ye(E) ; (E)-CF3CF=CHF",
    "HFO-1234ze(Z) ; (Z)-CF3CH=CHF",
    "HFO-1234ze(E) ; (E)-CF3CH=CHF",
    "HFO-1234yf ; CF3CF=CH2",
    "HFO-1336mzz(E) ; (E)-CF3CH=CHCF3",
    "HFO-1336mzz(Z) ; (Z)-CF3CH=CHCF3",
    "HFO-1243zf ; CF3CH=CH2",
    "HFO-1345zfc ; CF3CF2CH=CH2",
    "3,3,4,4,5,5,6,6,6-nonafluorohex-1-ene ; n-C4F9CH=CH2",
    "3,3,4,4,5,5,6,6,7,7,8,8,8-tridecafluorooct-1-ene ; n-C6F13CH=CH2",
    "3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,10-heptadecafluorodec-1-ene ; n-C8F17CH=CH2",
    "3,3,3-trifluoro-2-(trifluoromethyl)prop-1-ene ; (CF3)2C=CH2",
    "1,1,2,2,3,3-hexafluorocyclopentane ; cyc-CF2CF2CF2CH2CH2",
    "1,1,2,2,3,3,4-heptafluorocyclopentane ; cyc-CF2CF2CF2CHFCH2",
    "1,3,3,4,4,5,5-heptafluorocyclopentene ; cyc-CF2CF2CF2CF=CH",
    "(4s,5s)-1,1,2,2,3,3,4,5-octafluorocyclopentane ; trans-cyc-CF2CF2CF2CHFCHF",
    "HFO-1438ezy(E) ; (E)-(CF3)2CFCH=CHF",
    "HFO-1447fz ; CF3(CF2)2CH=CH2",
    "1,3,3,4,4-pentafluorocyclobutene ; cyc-CH=CFCF2CF2",
    "3,3,4,4-tetrafluorocyclobutene ; cyc-CH=CHCF2CF2",
    "PFC-14 ; CF4",
    "PFC-116 ; C2F6",
    "PFC-218 ; C3F8",
    "PFC-c216 ; c-C3F6",
    "PFC-C-318 (PFC-318) ; cyc-CF2CF2CF2CF2",
    "PFC-31-10 ; n-C4F10",
    "PFC-41-12 ; n-C5F12",
    "PFC-51-14 ; n-C6F14",
    "PFC-61-16 ; n-C7F16",
    "PFC-71-18 ; n-C8F18",
    "PFC-91-18 ; C10F18",
    "PFC-1114 ; CF2=CF2",
    "PFC-1216 ; CF3CF=CF2",
    "Pentadecafluorotriethylamine ; N(C2F5)3",
    "Perfluorotripropylamine ; N(CF2CF2CF3)3",
    "Heptacosafluorotributylamine ; N(CF2CF2CF2CF3)3",
    "Perfluorotripentylamine ; N(CF2CF2CF2CF2CF3)3",
    "Heptafluoroisobutyronitrile ; (CF3)2CFCN",
    "Trifluoromethylsulfur pentafluoride ; SF5CF3",
    "Sulfuryl fluoride ; SO2F2",
    "Hexafluoro-cyclobutene ; cyc-CF=CFCF2CF2",
    "Octafluoro-cyclopentene (Perfluorocyclopentene) ; cyc-CF=CFCF2CF2CF2",
    "1,1,2,2,3,3,4,4,4a,5,5,6,6,7,7,8,8,8a-octadecafluoronaphthalene (Perfluorodecalin (cis)) ; (Z)-C10F18",
    "1,1,2,2,3,3,4,4,4a,5,5,6,6,7,7,8,8,8a-octadecafluoronaphthalene (Perfluorodecalin (trans)) ; (E)-C10F18",
    "1,1,2,3,4,4-hexafluorobuta-1,3-diene ; CF2=CFCF=CF2",
    "Octafluoro-1-butene ; CF3CF2CF=CF2",
    "Octafluoro-2-butene ; CF3CF=CFCF3",
    "CFC-11 ; CCl3F",
    "CFC-12 ; CCl2F2",
    "CFC-13 ; CClF3",
    "CFC-112 ; CCl2FCCl2F",
    "CFC-112a ; CCl3CClF2",
    "CFC-113 ; CCl2FCClF2",
    "CFC-113a ; CCl3CF3",
    "CFC-114 ; CClF2CClF2",
    "CFC-114a ; CCl2FCF3",
    "CFC-115 ; CClF2CF3",
    "E-R316c ; trans-cyc-CClFCF2CF2CClF",
    "Z-R316c ; cis-cyc-CClFCF2CF2CClF",
    "CFC-1112 ; CClF=CClF",
    "CFC-1112a ; CCl2=CF2",
    "HCFC-21 ; CHCl2F",
    "HCFC-22 ; CHClF2",
    "HCFC-31 ; CH2ClF",
    "HCFC-121 ; CHCl2CCl2F",
    "HCFC-122 ; CHCl2CClF2",
    "HCFC-122a ; CHClFCCl2F",
    "HCFC-123 ; CHCl2CF3",
    "HCFC-123a ; CHClFCClF2",
    "HCFC-124 ; CHClFCF3",
    "HCFC-124a ; CHF2CClF2",
    "HCFC-132 ; CHClFCHClF",
    "HCFC-132a ; CHCl2CHF2",
    "HCFC-132c ; CH2FCCl2F",
    "HCFC-133a ; CH2ClCF3",
    "HCFC-141 ; CH2ClCHClF",
    "HCFC-141b ; CH3CCl2F",
    "HCFC-142b ; CH3CClF2",
    "HCFC-225ca ; CHCl2CF2CF3",
    "HCFC-225cb ; CHClFCF2CClF2",
    "HCFO-1233zd(E) ; (E)-CF3CH=CHCl",
    "HCFO-1233zd(Z) ; (Z)-CF3CH=CHCl",
    "(E)-1-chloro-2-fluoroethene ; (E/Z)-CHCl=CHF",
    "(E)-1-chloro-3,3,3-trifluoroprop-1-ene ; trans-CF3CH=CHCl",
    "Methyl chloroform ; CH3CCl3",
    "Carbon tetrachloride ; CCl4",
    "Methyl chloride ; CH3Cl",
    "Methylene chloride ; CH2Cl2",
    "Chloroform ; CHCl3",
    "Chloroethane ; CH3CH2Cl",
    "1,2-dichloroethane ; CH2ClCH2Cl",
    "1,1,2-trichloroethene ; CHCl=CCl2",
    "1,1,2,2-tetrachloroethene ; CCl2=CCl2",
    "2-chloropropane ; CH3CHClCH3",
    "1-chlorobutane ; CH3(CH2)2CH2Cl",
    "Methyl bromide ; CH3Br",
    "Methylene bromide ; CH2Br2",
    "Halon-1201 ; CHBrF2",
    "Halon-1202 ; CBr2F2",
    "Halon-1211 ; CBrClF2",
    "Halon-1301 ; CBrF3",
    "Halon-2301 ; CH2BrCF3",
    "Halon-2311 ; CHBrClCF3",
    "Halon-2401 ; CHBrFCF3",
    "Halon-2402 ; CBrF2CBrF2",
    "Tribromomethane ; CHBr3",
    "Halon-1011 ; CH2BrCl",
    "Bromoethane ; CH3CH2Br",
    "1,2-dibromoethane ; CH2BrCH2Br",
    "1-bromopropane ; CH3CH2CH2Br",
    "2-bromopropane ; CH3CHBrCH3",
    "HFE-125 ; CHF2OCF3",
    "HFE-134 ; CHF2OCHF2",
    "HFE-143a ; CH3OCF3",
    "HFE-227ea ; CF3CHFOCF3",
    "HCFE-235ca2 ; CHF2OCF2CHFCl",
    "HCFE-235da2 ; CHF2OCHClCF3",
    "HFE-236ea2 ; CHF2OCHFCF3",
    "HFE-236fa ; CF3CH2OCF3",
    "HFE-245cb2 ; CF3CF2OCH3",
    "HFE-245fa1 ; CHF2CH2OCF3",
    "HFE-245fa2 ; CHF2OCH2CF3",
    "2,2,3,3,3-pentafluoropropan-1-ol ; CF3CF2CH2OH",
    "HFE-254cb1 ; CH3OCF2CHF2",
    "HFE-254cb2 ; CH3OCF2CHF2",
    "HFE-236ca ; CHF2OCF2CHF2",
    "HFE-263mf (HFE-263fb2) ; CF3CH2OCH3",
    "HFE-263m1 ; CF3OCH2CH3",
    "HFE-365mcf2 ; CF3CF2OCH2CH3",
    "3,3,3-trifluoropropan-1-ol ; CF3CH2CH2OH",
    "HFE-329mcc2 ; CHF2CF2OCF2CF3",
    "HFE-338mmz1 ; (CF3)2CHOCHF2",
    "HFE-338mcf2 ; CF3CH2OCF2CF3",
    "HFE-347mmz1 ; (CF3)2CHOCH2F",
    "HFE-347mcc3 ; CH3OCF2CF2CF3",
    "HFE-347mcf2 ; CHF2CH2OCF2CF3",
    "HFE-347pcf2 ; CHF2CF2OCH2CF3",
    "HFE-347mmy1 ; (CF3)2CFOCH3",
    "HFE-356mec3 ; CH3OCF2CHFCF3",
    "HFE-356mff2 ; CF3CH2OCH2CF3",
    "HFE-356pcf2 ; CHF2CH2OCF2CHF2",
    "HFE-356pcf3 ; CHF2OCH2CF2CHF2",
    "HFE-356pcc3 ; CH3OCF2CF2CHF2",
    "HFE-356mmz1 ; (CF3)2CHOCH3",
    "HFE-365mcf3 ; CF3CF2CH2OCH3",
    "HFE-374pc2 ; CHF2CF2OCH2CH3",
    "4,4,4-trifluorobutan-1-ol ; CF3(CH2)2CH2OH",
    "2,2,3,3,4,4,5,5-octafluorocyclopentan-1-ol ; cyc-(CF2)4CH(OH)",
    "HFE-43-10pccc124 ; CHF2OCF2OCF2CF2OCHF2",
    "HFE-449s1 ; C4F9OCH3",
    "HFE-449sl ; C4F9OCH3",
    "n-HFE-7100 ; CF3CF2CF2CF2OCH3",
    "n-HFE-7200 ; n-C4F9OC2H5",
    "i-HFE-7100 ; (CF3)2CFCF2OCH3",
    "HFE-569sf2 ; C4F9OC2H5",
    "i-HFE-7200 ; (CF3)2CFCF2OCH2CH3",
    "HFE-7300 ; (CF3)2CFCFOC2H5CF2CF2CF3",
    "HFE-7500 ; n-C3F7CFOC2H5CF(CF3)2",
    "HFE-236ca12 ; CHF2OCF2OCHF2",
    "HFE-338pcc13 ; CHF2OCF2CF2OCHF2",
    "1,1,1,3,3,3-hexafluoropropan-2-ol ; (CF3)2CHOH",
    "HG-02 ; CHF2(OCF2CF2)2OCHF2",
    "HG-03 ; CHF2(OCF2CF2)3OCHF2",
    "HG-20 ; HF2C(OCF2)2OCF2H",
    "HG-21 ; HF2COCF2CF2OCF2OCF2OCF2H",
    "HG-30 ; HF2C(OCF2)3OCF2H",
    "Fluroxene ; CF3CH2OCH=CH2",
    "1,1,2,2-tetrafluoro-1-(fluoromethoxy)ethane ; CH2FOCF2CF2H",
    "2-ethoxy-3,3,4,4,5-pentafluorotetrahydro-2,5-bis[1,2,2,2-tetrafluoro-1-(trifluoromethyl)ethyl]furan ; C12H5F19O2",
    "Difluoro(methoxy)methane ; CH3OCHF2",
    "HG'-01 ; CH3OCF2CF2OCH3",
    "HG'-02 ; CH3O(CF2CF2O)2CH3",
    "HG'-03 ; CH3O(CF2CF2O)3CH3",
    "HFE-329me3 ; CF3CFHCF2OCF3",
    "3,3,4,4,5,5,6,6,7,7,7-undecafluoroheptan-1-ol ; CF3(CF2)4CH2CH2OH",
    "3,3,4,4,5,5,6,6,7,7,8,8,9,9,9-pentadecafluorononan-1-ol ; CF3(CF2)6CH2CH2OH",
    "3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,11-nonadecafluoroundecan-1-ol ; CF3(CF2)8CH2CH2OH",
    "2-chloro-1,1,2-trifluoro-1-methoxyethane ; CH3OCF2CHClF",
    "PFPMIE ; CF3OCF(CF3)CF2OCF2OCF3",
    "HFE-216 ; CF3OCF=CF2",
    "Perfluoroethyl formate ; CF3CF2OCHO",
    "2,2,2-trifluoroethyl formate ; CF3CH2OCHO",
    "Formic acid;1,1,1,3,3,3-hexafluoropropan-2-ol ; (CF3)2CHOCHO",
    "Ethenyl 2,2,2-trifluoroacetate ; CF3COOCH=CH2",
    "Ethyl 2,2,2-trifluoroacetate ; CF3COOCH2CH3",
    "Prop-2-enyl-2,2,2-trifluoroacetate ; CF3COOCH2CH=CH2",
    "Methyl 2,2,2-trifluoroacetate ; CF3COOCH3",
    "2,2,3,3,4,4,4-heptafluorobutan-1-ol ; CF3CF2CF2CH2OH",
    "1,1,2-trifluoro-2-(trifluoromethoxy)ethane ; CHF2CHFOCF3",
    "1-ethoxy-1,1,2,3,3,3-hexafluoropropane ; CF3CHFCF2OCH2CH3",
    "1,1,1,2,2,3,3-heptafluoro-3-(1,2,2,2-tetrafluoroethoxy)propane ; CF3CF2CF2OCHFCF3",
    "2,2,3,3-tetrafluoropropan-1-ol ; CHF2CF2CH2OH",
    "2,2,3,4,4,4-hexafluorobutan-1-ol ; CF3CHFCF2CH2OH",
    "1,1,2,2-tetrafluoro-3-methoxypropane ; CHF2CF2CH2OCH3",
    "1,1,1,2,2,4,5,5,5-nonafluoro-4-(trifluoromethyl)pentan-3-one ; CF3CF2COCF(CF3)2",
    "3,3,3-trifluoropropanal ; CF3CH2CHO",
    "2-fluoroethanol ; CH2FCH2OH",
    "2,2-difluoroethanol ; CHF2CH2OH",
    "2,2,2-trifluoroethanol ; CF3CH2OH",
    "HG-04 ; CHF2O(CF2CF2O)4CHF2",
    "Methyl-perfluoro-heptene-ethers ; CH3OC7F13",
    "1,1,1-trifluoro-propan-2-one ; CF3COCH3",
    "1,1,1-trifluoro-butan-2-one ; CF3COCH2CH3",
    "1-chloro-2-ethen-oxyethane ; ClCH2CH2OCH=CH2",
    "Octafluoro-oxolane ; c-C4F8O",
  ];
  const bulkuploadInputData = [
    [
      // {
      //   fieldName: "date",
      //   title: "Date",
      //   placeholder: "Date",
      //   disabled: true,
      //   colwidth: "48%",
      // },
      {
        fieldName: "productName",
        title: "Product Name",
        placeholder: "Product Name",
        type: "input",
        colwidth: "48%",
      },
    ],

    {
      header: "Sample Used for Testing",
      colwidth: "100%",
    },
    [
      {
        fieldName: "sampleBasis",
        title: "Sample Basis",
        placeholder: "Mass",
        type: "select",
        colwidth: "32%",
        options: ["Mass", "Volume", "Bulk", "Time", "Operational"],
      },
      {
        fieldName: "sampleQuantity",
        title: "Sample Quantity",
        placeholder: "Enter Quantity",
        colwidth: "31%",
      },
      {
        fieldName: "unit",
        title: "Unit",
        placeholder: "Unit",
        colwidth: "31.5%",
        options: simpleUnits,
      },
    ],
    [
      {
        fieldName: "processes.processName",
        title: "Process Name",
        placeholder: "Enter Process Name",
        colwidth: "47%",
      },
      {
        fieldName: "processes.emissions",
        title: "Emission to Air",
        placeholder: "Select",
        type: "select",
        colwidth: "50%",
        options: typeofemissions,
      },
    ],
  ];

  const filterData = [
    { title: "Date", type: "date", key: "createdAt", value: "" },
    {
      key: "consumptionMonth",
      type: "month",
      title: "Consumption Month",
      sortable: true,
    },
    {
      title: "Product",
      type: "option",
      key: "product",
      value: filters?.product?.map((el) => el?.productName),
    },
    {
      title: "Quantity Produced",
      type: "limit",
      key: "quantity",
      value: [],
      min: "minQty",
      max: "maxQty",
    },
  ];

  return (
    <MainDashboardLayout sidebar={<Scope1Layout />}>
      <Unauthorized requiredModule="Environment | Scope 1 | Fugitive Emissions">
        <Cards
          width="7rem"
          data={bannerData}
          title={"Fugitive Emissions"}
          onFilterChange={handleSelectChange}
          {...{
            setSelectedMonth,
            setSelectedYear,
            selectedMonth,
            selectedYear,
          }}
        />
        <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
        <ActionButtons
          onFilterClick={() => setIsFilterModalOpen(true)}
          onAddClick={() => openModal("add")}
          filterObj={filterObj}
          onUploadClick={() => setBulkUploadModal(true)}
        />
        <ViewTable
          tableContainerRef={tableContainerRef}
          headers={headers}
          data={tableData ?? []}
          onSort={handleSort}
          sortConfig={sortConfig}
          totalPages={totalPages}
          page={currentPage}
          isShortContent={isShortContent}
          editIcon={user?.companyAdmin && "disable"}
          field="unit"
          title={"Industrial Process Release"}
          count={page}
          onPageChange={handlePageChange}
          onView={(row) => {
            openViewModal(row);
          }}
          onEdit={(row) => openModal("edit", row)}
          onDelete={(row) => handleDeleteOpen(row._id)}
        />
        <Add
          handleClose={() => closeModal(editModal ? "edit" : "add")}
          id={editData ? editData._id : ""}
          title="Industrial Process Release"
          addData={editModal ? editModal : isModalOpen}
          addUrl={`/scope1/fugitiveEmission/addIndustrialProcess`}
          updateUrl={`/scope1/fugitiveEmission/updateIndustrialProcess`}
          {...{
            fetchData,
            setsnackOpen,
            inputData,
            element: editData,
            setAddData: setEditModal,
          }}
        />
        <View
          id={editData ? editData._id : ""}
          element={editData}
          title={"Industrial Process Release Details"}
          viewData={viewModal}
          setData={setEditData}
          setViewData={setViewModal}
          inputData={inputData}
          handleEdit={handleEdit}
        />
        {deleteDialog && (
          <DeleteAlertDialog
            fetchData={updatePage}
            {...{
              deleteDialog,
              setDeleteDialog,
              id: deletedItemId,
              url: `/scope1/fugitiveEmission/deleteIndustrialProcess`,
              setsnackOpen,
            }}
          />
        )}
        <FilterModal
          isOpen={isFilterModalOpen}
          onClose={() => setIsFilterModalOpen(false)}
          filters={filterData}
          onFilterChange={handleFilterChange}
          title="Filter"
        />
        {bulkUploadModal && (
          <BulkUploadModal
            onCloseBulkUpload={handleCloseBulkUpload}
            isBulkUploadModal={bulkUploadModal}
            excelData={excelData}
            setFormDataBulkUpload={setFormDataBulkUpload}
            formDataBulkUpload={formDataBulkUpload}
            setMatchData={setMatchData}
            errorClose={uploadErrorClose}
            matchedKey="ProductStatusList"
            setBulkUploadTable={setBulkUploadTable}
            setBulkUploadModal={setBulkUploadModal}
            fileName={"Industrial Process Release"}
            url={"/scope1/fugitiveEmission/industrialProcess/bulkupload"}
            setsnackOpen={setsnackOpen}
          />
        )}
        {bulkUploadTable && (
          <BulkUpload
            matchData={matchData}
            setMatchData={setMatchData}
            onClose={() => setBulkUploadTable(false)}
            bulkUploadTable={bulkUploadTable}
            url={`/master/product/getAll`}
            // onAddItem={handleAddItem}
            simpleUnits={simpleUnits}
            typeofemissions={typeofemissions}
            setFormData={setFormDataBulkUpload}
            formData={formDataBulkUpload}
            submitUrl={`/master/product/create`}
            bulkuploadInputData={bulkuploadInputData}
            onConfirm={() => {
              // Handle the bulk upload confirmation here
              setBulkUploadTable(false);
              fetchData();
              setsnackOpen({
                open: true,
                message: "Bulk upload completed successfully!",
                severity: "success",
              });
            }}
            jsonBulkUpload={formDataBulkUpload}
            bulkUploadUrl="/scope1/fugitiveEmission/industrialProcess/jsonupload"
            setsnackOpen={setsnackOpen}
            fieldName="Product Name"
          />
        )}
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default IndustrialProcess;
